const config = {
    siteUrl: process.env.REACT_APP_SITE_URL || "https://casadasescadinhas.com",
    propertyName: "Casa das Escadinhas",
    propertyLocation: "Portugal",
    // Dedicated social-share image (1200×630) used for Open Graph / Twitter
    // cards on every page. Generated by client/scripts/generate-og-image.js and
    // served from the build root at /og-image.jpg.
    ogImage: "/og-image.jpg",
    // Supported languages. The first entry is the default/fallback — the one that
    // x-default and bare-URL redirects resolve to. Single source of truth shared
    // by i18n (UI), the router (URL language prefixes /en /de …), the hreflang
    // tags, and the sitemap generator, so none of them can drift apart.
    languages: ['en', 'de', 'es', 'fr', 'it', 'pt'],
    defaultLanguage: 'en',
    // Public Google Business Profile / Maps URL. Set this once the profile is
    // verified so the LodgingBusiness schema can link the site to the Maps
    // listing via sameAs (e.g. "https://maps.google.com/?cid=..."). Null hides it.
    googleBusinessUrl: null,
    address: "6 Rua da Encosta dos Moledos,\n8650-151 Budens,\nPortugal",
    coordinates: {
        lat: 37.073408217993254,
        lng: -8.851941801384736,
    },
    photo: {
        categories: ['exterior', 'lower-living', 'lower-kitchen', 'lower-bedroom', 'lower-bathroom', 'upper-bathroom', 'upper-bedroom-1', 'upper-bedroom-2', 'upper-kitchen', 'upper-living', 'upper-terrasse', 'exterior-lower-front']
    },
    // Property details for Schema.org structured data
    property: {
        description: "Recently renovated apartment accommodation in Budens, Algarve, with one-bedroom and two-bedroom apartments, garden, terrace, air conditioning, equipped kitchens, WiFi in public areas, and free public on-site parking.",
        numberOfBedrooms: 3,
        numberOfBathrooms: 2,
        maxOccupancy: 7,
        minOccupancy: 1,
        floorSize: {
            value: 168,
            unitCode: "MTK" // Square meters
        },
        geo: {
            latitude: 37.073408217993254,
            longitude: -8.851941801384736
        },
        streetAddress: "6 Rua da Encosta dos Moledos",
        addressLocality: "Budens",
        addressRegion: "Algarve",
        postalCode: "8650-151",
        addressCountry: "PT",
        amenities: [
            "Air conditioning",
            "Heating",
            "Free WiFi in public areas",
            "Kitchen",
            "Washing machine",
            "Free public on-site parking",
            "Garden",
            "Terrace",
            "Outdoor furniture",
            "Flat-screen TV",
            "Coffee maker",
            "Dishwasher",
            "Oven",
            "Microwave",
            "Toaster",
            "Kettle",
            "Safety deposit box",
            "Fire extinguisher",
            "Private check-in/check-out",
            "Bed linens provided",
            "Towels provided",
            "Ironing facilities"
        ],
        images: [
            "/images/exterior/exterior-1.jpg",
            "/images/upper-living/upper-living-1.jpg",
            "/images/lower-kitchen/lower-kitchen-1.jpg",
            "/images/upper-bedroom-1/upper-bedroom-1-1.jpg",
            "/images/upper-terrasse/upper-terrasse-1.jpg"
        ]
    },
    // The property is two independently bookable apartments (plus a whole-house option).
    // Structural data + which photo categories / booking links belong to each unit live here;
    // all customer-facing copy lives in i18n (the `apartments` namespace).
    apartments: {
        garden: {
            id: 'garden',
            slug: 'garden-apartment',
            floor: 'lower',
            bedrooms: 1,
            bathrooms: 1,
            maxGuests: 3, // TODO: confirm against the live Airbnb listing
            floorSize: null, // m² per unit — TODO: confirm
            heroCategory: 'lower-living',
            photoCategories: ['exterior-lower-front', 'lower-living', 'lower-kitchen', 'lower-bedroom', 'lower-bathroom'],
            airbnbUrl: 'https://www.airbnb.com/rooms/1097576939597067618',
            bookingUrl: 'https://www.booking.com/hotel/pt/casa-das-escadinhas-budens.html',
        },
        terrace: {
            id: 'terrace',
            slug: 'terrace-apartment',
            floor: 'upper',
            bedrooms: 2,
            bathrooms: 1,
            maxGuests: 4, // TODO: confirm against the live Airbnb listing
            floorSize: null,
            heroCategory: 'upper-terrasse',
            photoCategories: ['upper-living', 'upper-kitchen', 'upper-bedroom-1', 'upper-bedroom-2', 'upper-bathroom', 'upper-terrasse'],
            airbnbUrl: 'https://www.airbnb.com/rooms/1097927393012537417',
            bookingUrl: 'https://www.booking.com/hotel/pt/casa-das-escadinhas-budens.html',
        },
    },
    // ── PRICING — single source of truth ──────────────────────────────────
    // Everything the site shows as a price reads from here. To change a rate,
    // edit only the numbers below; nothing else needs to be touched.
    //   currency : ISO code used to format every price (EUR → "€120").
    //   nightly  : the per-night rate for each apartment. The whole house is
    //              the price for renting both apartments together.
    //   Set a value to null to hide the number and show "Price on request".
    pricing: {
        currency: "EUR",
        nightly: {
            garden: 165,      // e.g. 80
            terrace: 180,     // e.g. 110
            wholeHouse: 340,  // e.g. 180
        },
    },
    providers: {
        airbnb: {
            url: 'https://www.airbnb.com/rooms/1097927393012537417',
            urlUpperFloor: 'https://www.airbnb.com/rooms/1097927393012537417',
            urlLowerFloor: 'https://www.airbnb.com/rooms/1097576939597067618',
            reviewsUrl: 'https://www.airbnb.com/rooms/1097927393012537417#reviews',
            iCal: null
        },
        booking: {
            url: 'https://www.booking.com/hotel/pt/casa-das-escadinhas-budens.html',
            reviewUrl: '',
            iCal: ''
        },
        vrbo: null,
        // Direct booking (if you set this up later)
        directBookingEnabled: false,
        directBookingUrl: null,
    },
    contact: {
        email: "casadasescadinhas2023@gmail.com",
        phone: "+33646850689",
        // WhatsApp click-to-chat number. Assumed the same as the phone above —
        // confirm it is WhatsApp-enabled, or set a different number / null to hide.
        whatsapp: "+33646850689",
    },
    manager: {
        name: "Romantik villa",
        url: "https://www.romantikvilla.com/",
    },

    social: {
        instagram: null,
        facebook: null,
    },

};

module.exports = config
